import { JudgeBlockShell } from '../components/competition/judge-block/JudgeBlockShell';

/**
 * One block on the wall, scored by the judge standing at it — boulder or lead
 * alike: the classes that climb it are its tabs (see JudgeBlockShell).
 */
export default function JudgeBlock() {
  return <JudgeBlockShell />;
}
